import { Spin } from 'antd';
import type { ReactNode } from 'react';
import cn from 'classnames';
import styles from './style.module.css';

interface Props {
  children: ReactNode;
  spinning: boolean;
  className?: string;
}

export const LoadingOverlay = ({ children, spinning, className }: Props) => (
  <div
    className={cn(styles.overlayHost, className)}
    aria-busy={spinning}
    aria-live="polite"
  >
    {children}
    {spinning ? (
      <div className={styles.overlay}>
        <Spin tip="Загрузка..." />
      </div>
    ) : null}
  </div>
);
